import React from 'react';
import { KiteIcon } from '@kite/react-kite';
interface CollapsibleTableHeaderInputs {
    header: string;
    headerRight: string;
    quantityLabel: string;
    tableType: string;
    subHeader?: string;
    subHeaderRight?: string;
    expanded: boolean;
    setExpanded: React.Dispatch<React.SetStateAction<boolean>>;
}

export const CollapsibleTableHeader = ({
    header,
    headerRight,
    quantityLabel,
    tableType,
    subHeader,
    subHeaderRight,
    expanded,
    setExpanded,
}: CollapsibleTableHeaderInputs) => {
    const SecondaryTableHeader = () => {
        return (
            <>
                <h2 className="table-heading">
                    <span className="typestack-title-3">{header}</span>
                </h2>
                <h3 className="table-subheading typestack-title-5">
                    <span>{subHeader}</span>
                    <span>{subHeaderRight}</span>
                </h3>
            </>
        );
    };
    const PrimaryTableHeader = () => {
        return (
            <>
                <h2>
                    <button
                        onClick={() => {
                            setExpanded(!expanded);
                        }}
                        type="button"
                        aria-expanded={expanded}
                        aria-controls="cdfiPartners"
                    >
                        <span className="typestack-title-3">{header}</span>
                        {headerRight && (
                            <span className="typestack-title-3">
                                {headerRight}
                            </span>
                        )}
                    </button>
                </h2>
                <p className="subheader">
                    <span>{quantityLabel}</span>
                    <button
                        onClick={() => {
                            setExpanded(!expanded);
                        }}
                        type="button"
                        aria-expanded={expanded}
                        aria-controls="cdfiPartners"
                    >
                        View Details{` `}
                        <KiteIcon icon="ki-chevron-up"></KiteIcon>
                    </button>
                </p>
            </>
        );
    };

    return (
        <>
            {tableType === `secondary` ? (
                <SecondaryTableHeader />
            ) : (
                <PrimaryTableHeader />
            )}
        </>
    );
};
